import axios from 'axios'
import type {
  ReiRegistration,
  ReiRegistrationPayload,
  ReiRegistrationsResponse,
  ReiRegistrationStatus,
  ReiValidationResponse,
} from './types'

const REI_API_URL = import.meta.env.VITE_REI_API_URL || 'http://localhost:8081'

const reiApi = axios.create({
  baseURL: REI_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
})

reiApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  const workspaceId = localStorage.getItem('currentWorkspaceId')
  if (workspaceId) {
    config.headers['X-Workspace-Id'] = workspaceId
  }

  return config
})

export const reiService = {
  async list(status?: ReiRegistrationStatus) {
    const response = await reiApi.get<ReiRegistrationsResponse>('/api/rei/registrations', {
      params: status ? { status } : undefined,
    })
    return response.data
  },

  async getById(id: string) {
    const response = await reiApi.get<{ data: ReiRegistration }>(`/api/rei/registrations/${id}`)
    return response.data.data
  },

  async validate(payload: ReiRegistrationPayload) {
    const response = await reiApi.post<ReiValidationResponse>('/api/rei/registrations/validate', { payload })
    return response.data
  },

  async create(payload: ReiRegistrationPayload) {
    const response = await reiApi.post<{ data: ReiRegistration }>('/api/rei/registrations', payload)
    return response.data.data
  },

  async update(id: string, payload: ReiRegistrationPayload) {
    const response = await reiApi.put<{ data: ReiRegistration }>(`/api/rei/registrations/${id}`, payload)
    return response.data.data
  },

  async updateStatus(id: string, registration_status: ReiRegistrationStatus) {
    const response = await reiApi.patch<{ data: ReiRegistration }>(`/api/rei/registrations/${id}/status`, {
      registration_status,
    })
    return response.data.data
  },

  async remove(id: string) {
    await reiApi.delete(`/api/rei/registrations/${id}`)
  },
}
